import React from 'react';
import {ShowGuesser} from "@api-platform/admin";

const FlightShow = (props) => {
    return (
            <ShowGuesser {...props} />
    );
};

export default FlightShow;
